export default class User {
    constructor () {
        this.id = null,
        this.yodiz_user_id = null,
        this.role_id = null,
        this.name = null,
        this.email = null,
        this.type = null,
        this.password = ""
    }
}